import createVueComponent from '../createVueComponent';

const RotateCw = createVueComponent('RotateCwIcon', [
  ['path', { d: 'M21 2v6h-6' }],
  ['path', { d: 'M21 13a9 9 0 11-3-7.7L21 8' }],
]);

export default RotateCw;
